import LoginCallback from '../callback';
import ROUTES from '~/assets/javascript/constants/routes';
import { last, omit } from 'lodash';

export class Module {
  constructor(nuxt) {
    this.$api = nuxt.$api;
    this.$auth = nuxt.$auth;
    this.$recaptcha = nuxt.$recaptcha;
    this.$router = nuxt.$router;
    this.callbackHandler = new LoginCallback(nuxt);
    this.$localePath = nuxt.$localePath;
  }

  get route() {
    return this.$router.currentRoute.value;
  }

  async login({ token, username = null, tenantSlug = null, redirectTo = null }) {
    const result = await this.$auth.loginWith('local', {
      url: 'authentication/magic_link',
      method: 'post',
      body: { token },
    });

    this.route.query = omit(this.route.query, ['token', 'username', 'tenant_slug']);

    if (result?._data?.status === 'awaiting_mfa') {
      return this.$router.push(this.$localePath({
        name: ROUTES.public.mfa.routeName,
        params: { tenantSlug },
        query: { ...this.route.query, username: encodeURIComponent(username) },
      }));
    }

    return this.callbackHandler.handle({ withQuery: true, redirectTo });
  }

  async send({ email }) {
    // In case login has redirect to query param, e.g.: `redirectTo=/t/tenant/install/app`
    const redirectToApp = last(this.route.query?.redirectTo?.split('/')) || null;
    const app = this.route.query?.utm_app || redirectToApp;

    await this.$recaptcha.fetchToken(async token => this.$api
      .post('authentication/magic_link/send', {
        body: {
          email,
          tenant_slug: this.route.params.tenantSlug,
          app,
          recaptcha_token: token,
        },
      }));
  }
}

export function SetupMagicLink(nuxt) {
  nuxt.$auth.magicLinkModule = new Module(nuxt);
}
